import styled from 'styled-components';


export const InputMessageErrorText = styled.span`
    padding: 5px;
    color: red;
    font-size: 0.7rem;
`;